import React from "react";
import "../css/dashboard.css";
import Navbar from "../component/Navbar";
import AccountContent from "./AccountContent";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import AccountContentMobile from "./AccountContentMobile";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

export default function Account() {
  const navigate = useNavigate();
  const handleMenuOpen = () => {
    navigate("/menumobile");
  };

  const isMobile = useMediaQuery({ query: "(max-width: 800px)" });
  return (
    <div className="main-container">
      {isMobile ? (
        <>
          <div className="menu-button-container">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleMenuOpen}
              className="menu-button"
            >
              <MenuIcon />
            </IconButton>
          </div>

          <AccountContentMobile />
        </>
      ) : (
        <>
          <Navbar linkActive={7} />
          <AccountContent />
        </>
      )}
    </div>
  );
}
